import { Button } from "@/components/ui/button";
import Icons from "../../icons";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import {useState, useEffect} from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useNavigate } from 'react-router-dom';
export const CreateTeam = ({ children }: { children: React.ReactNode }) => {
    const [imageSrc, setImageSrc] = useState<string | null>(null);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [teamName, setTeamName] = useState('');
    const [teamNameError, setTeamNameError] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [imageError, setImageError] = useState('');
    const navigate = useNavigate();
    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = async () => {
                const formData = new FormData();
                formData.append("image", file);
                formData.append("type", "teamIcon");
                const res = await fetch("__SITE_BASE__/api/v1/upload", {
                    method: "POST",
                    body: formData
                });
                const data = await res.json();
                if (res.ok) {
                    document.getElementById('preview')?.classList.remove('hidden');
                    setImageSrc(data.url);
                } else {
                    setImageError(data.message);
                }
            };
            reader.readAsDataURL(file);
        }
    };

        useEffect(() => {
            const teamNameStr = String(teamName);
            if (teamNameStr.length === 0) {
                setTeamNameError('');
                setButtonDisabled(true);
            } else if (teamNameStr.length < 3) {
                setTeamNameError('Team name must be at least 3 characters long');
                setButtonDisabled(true);
            } else if (teamNameStr.length > 12) {
                setTeamNameError('Team name must be less than 12 characters long');
                setButtonDisabled(true);
            } else {
                setTeamNameError('');
                setButtonDisabled(false);
            }
        }, [teamName]);

        const create = async () => {
            setButtonDisabled(true);
            const response = await fetch("__SITE_BASE__/api/v1/teams", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: teamName,
                    profilePicture: imageSrc
                })
            });
            const data = await response.json();
            if (response.ok) {
                setIsOpen(false);
                navigate(`/teams/${data.createdTeam.id}`);
            } else {
                setTeamNameError(data.message || "An error occurred while creating the team.");
                setButtonDisabled(false);
            }
        }

        return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 ">
                <DialogHeader className="items-center justify-center">
                    <DialogTitle>
                        Personalize your team
                    </DialogTitle>
                    <DialogDescription>
                        Create a team to manage your projects and tasks
                    </DialogDescription>
                </DialogHeader>
                    <div className="flex items-center justify-center gap-4">
                        <div className="flex flex-col items-center justify-center gap-1">
                            {imageError && <p className="text-red-500 text-sm">{imageError}</p>}
                            <div className="relative w-32 h-32 mt-4 items-center cursor-pointer" onClick={() => document.getElementById('image')?.click()}>
                                <div className="flex items-center justify-center w-full h-full bg-brand-darkest border-dashed border-2 border-brand-green rounded-lg overflow-hidden">
                                    <img id="preview" src={imageSrc ?? undefined} className="absolute inset-0 object-cover w-full h-full hidden rounded" alt="Preview Image" />
                                    <Icons name="picture" size="32" color="white" />
                                    <input type="file" id="image" className="hidden" accept="image/png" required onChange={handleImageChange} />
                                </div>
                                <div className="absolute bottom-[-10px] right-[-10px] bg-gradient-to-br from-green-500/50 to-green-600/50 rounded-full w-8 h-8 flex items-center justify-center">
                                    <Icons name="plus" size="24" color="white" />
                                </div>
                            </div>
                            <span className="text-sm text-gray-400 mt-2">
                                (Max. 5MB)
                            </span>
                        </div>
                    </div>

                    <Label>Team Name</Label>
                    {teamNameError && <p className="text-red-500 text-sm">{teamNameError}</p>}
                    <Input
                        className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300"
                        placeholder="Team Name"
                        type="text"
                        autoComplete="false"
                        onChange={(e) => {setTeamName(e.target.value)}}
                    />
                    <div className="flex items-center justify-center mt-2">
                        <Button className="bg-brand-green px-5 py-2 w-full rounded-lg text-white font-semibold hover:bg-green-500" disabled={buttonDisabled} onClick={create}>
                            Create Team
                        </Button>
                    </div>
            </DialogContent>
        </Dialog>
    );

};